require("./appMetaService");
require('./currentPlatform/currentPlatformDetailService');
require('./currentUser/currentUser');
require('./../sessionTimeout/sessionTimeoutService');

"use strict";

angular.module('app.appController', [
    'app.appMetaService',
    'app.currentPlatform.currentPlatformDetailService',
    'app.currentUser',
    'app.sessionTimeout.sessionTimeoutService'
])
    .controller('app.appController', [
        '$scope', 'appMetaService', 'app.currentPlatform.currentPlatformDetailService', 'currentUser', '$state', '$rootScope', '$document',
        'sessionTimeoutService',
        function ($scope, appMeta, currentPlatformDetail, currentUser, $state, $rootScope, $document, sessionTimeout) {
            $scope.appMeta = appMeta;
            $scope.currentPlatformDetail = currentPlatformDetail;
            $scope.state = $state;
            $scope.pageTitle = $scope.appMeta.longName;

            let init = function () {
                currentPlatformDetail.retrieve();
            };

            // Update page title when state changes
            $scope.$watch(function () {
                return $scope.state.current.title;
            }, function () {
                if ($scope.state.current.title) {
                    $scope.pageTitle = $scope.state.current.title;
                } else {
                    $scope.pageTitle = $scope.appMeta.longName;
                }
            });

            $scope.$watch(function () {
                return currentUser.is_logged_in();
            }, function() {
                let d = new Date();
                let n = d.getTime();  //n in ms

                $rootScope.idleEndTime = n + (360 * 60 * 1000); //set end time to 360 min or 6 hrs from now
                $document.find('body').on('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart', sessionTimeout.checkAndResetIdle);
            });



            init();
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/appController.js